<template>
  <div id="DocumentLimitTransactionDebtorInformation" class="sun not-full">
    <div class="title">
      개인(신용)정보 조회 동의서
    </div>
    <br/>
    <br/>
    <div class="content">
      <p>(주)펀다 귀중<br />귀사와의 금융거래와 관련하여 귀사가 본인의 개인(신용)정보를 수집&middot;이용&middot;제공하고 본인의 개인(신용)정보를 조회하기 위해서는 「개인정보보호법」 및 「신용정보의 이용 및 보호에 관한 법률」등에 따라 본인의 동의가 필요합니다. 이에 본인은 귀사가 아래와 같이 본인의 개인(신용)정보를 수집&middot;이용&middot;제공,조회 하는 것에 대해 동의합니다.</p>
      <p>&nbsp;</p>
      <br/><br/>
      <p><strong>1.개인(신용)정보의 조회 대상 기관</strong><br />신용정보집중기관 : (사)한국신용정보원 등<br />신용정보조회회사 : 코리아크레딧뷰로(주), NICE평가정보 주식회사, 한국평가정보 주식회사</p>
      <br/><br/>
      <p><strong>2.조회할 개인(신용)정보의 항목</strong><br />개인식별정보 : 성명, 주민등록번호, 사업자번호, 주민등록증(운전면허증) 발급일, 연락처, 주소(자택,직장), E-mail, 본인인증정보, 직장정보, 성별, 국적, 운전면허정보, 여권번호, 외국인등록번호 등<br />신용거래정보 : 대출, 보증, 담보제공, 당좌거래, 신용카드, 할부금융, 시설대여와 금융거래 등 상거래와 관련하여 그 거래의 종류, 기간, 금액 및 한도 등에 관한 사항<br />신용도정보 : 연체, 부도, 대위변제, 대지급, 신용질서 문란행위와 관련된 금액 및 발생˙해소의 시기 등에 관한 사항<br />신용능력정보 : 재산, 채무, 소득의 총액, 납세실적 등 신용거래능력을 판단할 수 있는 정보<br />공공기관정보 : 개인회생, 파산, 면책 등에 관한 신청 및 법원의 결정 관련정보, 채무불이행자명부 등재˙말소 결정, 체납정보, 주민등록관련정보, 사회보험료˙공공요금˙수수료 관련 정보 등<br />신용관련정보 : 신용등급, 신용평점, 신용평가모형, 개인회생관련정보, 신용조회기록 등</p>
      <br/><br/>
      <p><strong>3.개인(신용)정보의 조회 목적</strong><br />계약의 체결&middot;이행&middot;유지&middot;관리, 채권추심, 신용관련 모형개발 및 (통계)분석, 상품&middot;서비스 안내 및 이용권유 등</p>
      <br/><br/>
      <p><strong>4.개인(신용)정보의 조회 동의 효력기간</strong><br />당해 계약의 종료일(예: 기간만기, 계약해지 등) 및 동의철회시까지 동의의 효력이 유지됩니다.<br />다만, 관련법규에 별도 규정이 있는 경우 그 기간을 따르며, 신용관련 모형개발 및 (통계)분석은 예외로 합니다.</p>
      <br/><br/>
      <p><strong>5.조회자의 개인(신용)정보의 보유 및 이용기간</strong><br />개인(신용)정보의 조회목적을 달성할 때까지<br />다만, 관련법규에 별도 규정이 있는 경우 그 기간을 따릅니다.<br /><br />※귀하는 개인(신용)정보 조회 동의를 거부할 권리가 있으나, 위 정보는 서비스 제공에 필수적으로 필요한 정보이므로 동의하지 않는 경우에는 계약의 체결&middot;이행&middot;유지&middot;관리 등이 불가능할 수 있음을 알려드립니다.<br />※신용조회회사를 통하여 개인(신용)정보를 조회한 기록에 의해 개인신용평점이 하락할 수 있음을 알려드립니다.<br />※본 동의 이후 동일한 목적 또는 이용범위 내에서 개인(신용)정보의 정확성,최신성을 유지하기 위해 제공&middot;조회하는 경우에는 별도의 추가 동의가 필요하지 않습니다.</p>

    </div>
    <div class="agree" ref="step1">
      개인(신용)정보 조회에 대한 내용에
      <button @click="agree()"
              :style="{'color': (isComplete?'#1baaf1':'#727d8c')}">
        동의함
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentLimitTransactionDebtorInformation',
  props: {
    isAgreed: {
      type: Boolean,
      default() { return false }
    }
  },
  data: function () {
    return {
      isComplete: false
    }
  },
  computed: {},
  created() {
    if (this.isAgreed) {
      this.isComplete = true
    }
  },
  destroyed() {},
  methods: {
    agree() {
      this.isComplete = !this.isComplete
      this.checkAll()
    },
    checkAll() {
      if (this.isComplete) {
        this.complete()
      } else {
        this.notcomplete()
      }
    },
    complete() {
      this.$emit('complete')
    },
    notcomplete() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
  #DocumentLimitTransactionDebtorInformation {
    padding-top: 30px;
    padding-bottom: 11px;
    .title {
      font-weight: 900;
      font-size: 16px;
      line-height: 1.5;
      color: #333333;
    }

    .content {
      line-height: 1.5;
      div:not(:last-child) {
        margin-bottom: 10px;
      }
    }

    .agree {
      font-weight: 600;
      font-size: 16px;
      line-height: 48px;
      margin-top: 12px;
      width: 100%;

      button {
        width: 80px;
        height: 48px;
        border-radius: 4px;
        border: solid 1px #d7e1ea;
        background-color: #ffffff;
        font-size: 15px;
        line-height: 1.6;
        float: right;
      }
    }
  }

  @media screen and (max-width: 350px) {
    .agree {
      font-size: 14px !important;
      letter-spacing: -0.5px;
    }
  }
  @media screen and (min-width: 350px) and (max-width: 374px) {
    .agree {
      font-size: 15px !important;
      letter-spacing: -0.5px;
    }
  }
</style>
